import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import useOdooCustomers from "hooks/useOdooCustomers";
import { useState } from "react";
import { searchByProp } from "utils/search";

const OdooCustomersView = ({
  instance = "AB",
  initialSearchText = "",
  useType,
  onSelect,
}) => {
  const { loading, error, odooCustomers } = useOdooCustomers({
    instance,
    useType,
  });
  const [searchText, setSearchText] = useState(initialSearchText);

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const customers = odooCustomers
    .filter((i) => i.name)
    .filter((i) => searchByProp(i, ["name", "email", "vat"], searchText));

  return (
    <div className="text-sm">
      <div>
        <SearchBar
          value={searchText}
          onChange={setSearchText}
          placeholder="Search by name, email or vat"
        />
      </div>

      <div className="mt-2 divide-y dark:divide-gray-700">
        {customers.map((customer) => (
          <div
            key={customer.id}
            className="py-2 cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-900"
            onClick={() => onSelect(customer)}
          >
            <div>{customer.name}</div>
            <div className="text-xs">{customer.email}</div>
          </div>
        ))}

        {customers.length === 0 && (
          <div className="text-red-600 opacity-70 text-xs">
            No customers found in odoo for `{searchText}`.
          </div>
        )}
      </div>
    </div>
  );
};

export default OdooCustomersView;
